import { Fragment, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { consultantUpdate, getConsultant } from "../../service/consultantService";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { PhoneInput } from "react-international-phone";
import { AlternateEmailOutlined } from "@mui/icons-material";

import { Avatar } from "primereact/avatar";

import S3DocumentsUpload from "../../components/S3DocumentsUpload";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { AddressSearch } from "../../components/Shared/Address/AddressSearch";

export default function ConsultantsView(props: RouteComponentProps) {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState({} as any);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminMobile, setAdminMobile] = useState("");
  const [industry, setIndustry] = useState([]);
  const [adminName, setAdminName] = useState("");
  const [adminSurname, setAdminSurname] = useState("");
  const [name, setName] = useState("");
  const [physicalAddress, setPhysicalAddress] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [sacpcmpId, setSacpcmpId] = useState("");
  const [sacpcmpFullName, setSacpcmpFullName] = useState("");
  const [sacpcmpGoodStandingFrom, setSacpcmpGoodStandingFrom] = useState("");
  const [sacpcmpGoodStandingTo, setSacpcmpGoodStandingTo] = useState("");
  const [sacpcmpImgSrc, setSacpcmpImgSrc] = useState("");
  const [sacpcmpMembershipNumber, setSacpcmpMembershipNumber] = useState("");
  const [sacpcmpRegistrationCategory, setSacpcmpRegistrationCategory] = useState("");
  const [sacpcmpRegistrationNumber, setSacpcmpRegistrationNumber] = useState("");
  const [sacpcmpRegistrationStatus, setSacpcmpRegistrationStatus] = useState("");
  const [sacpcmpTitle, setSacpcmpTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useRef(null as any);

  const loadLazyData = (id: string | undefined) => {
    if (!id) return;
    if (!loading) {
      props.setGlobalLoader(true);
      setLoading(true);
      getConsultant(id)
        .then(data => {
          console.log("getConsultant == ", data);
          setData(data);
          setAdminEmail(data.admin_email);
          setAdminMobile(data.admin_mobile);
          setAdminName(data.admin_name);
          setAdminSurname(data.admin_surname);
          setName(data.name);
          setPhysicalAddress(data.physical_address);
          setRegistrationNumber(data.registration_number);
          setVatNumber(data.vat_number);
          setSacpcmpId(data.sacpcmp_id);
          setIndustry(data.industry);
          setSacpcmpFullName(data.sacpcmp_full_name);
          setSacpcmpGoodStandingFrom(data.sacpcmp_good_standing_from?.substring(0, 10));
          setSacpcmpGoodStandingTo(data.sacpcmp_good_standing_to?.substring(0, 10));
          setSacpcmpImgSrc(data.sacpcmp_img_src);
          setSacpcmpMembershipNumber(data.sacpcmp_membership_number);
          setSacpcmpRegistrationCategory(data.sacpcmp_registration_category);
          setSacpcmpRegistrationNumber(data.sacpcmp_registration_number);
          setSacpcmpRegistrationStatus(data.sacpcmp_registration_status);
          setSacpcmpTitle(data.sacpcmp_title);
          setLoading(false);
          setTimeout(() => {
            props.setGlobalLoader(false);
          }, 1000);
        })
        .catch(error => {
          console.log("error == ", error);
          setData({});
          props.setGlobalLoader(false);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    loadLazyData(id);
  }, [id]);

  async function updateConsultant() {
    const updateObject = {
      admin_email: adminEmail,
      admin_mobile: adminMobile,
      admin_name: adminName,
      admin_surname: adminSurname,
      name: name,
      physical_address: physicalAddress,
      registration_number: registrationNumber,
      vat_number: vatNumber,
      sacpcmp_id: sacpcmpId,
      industry,
    };
    props.setGlobalLoader(true);
    consultantUpdate(updateObject, id).then((r: any) => {
      toast.current.show({
        severity: "success",
        summary: "Consultant Updated Successfully",
        life: 3000,
      });
      loadLazyData(id);
    });
  }

  const record_id = props.session?.consultant_id || "";

  return (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
        <Button
          type="button"
          icon="pi pi-save"
          label="Save"
          className="p-button-outlined"
          size="small"
          style={{ fontSize: "small", color: "#2dd36f" }}
          onClick={() => updateConsultant()}
        />
      </div>
      <TabView>
        <TabPanel header="Company Details">
          <Card>
            <Grid container spacing={2}>
              {/* <Grid item xs={12}>
                <S3ImagePreview />
              </Grid> */}
              <Grid item xs={12}>
                <FormLabel style={{ marginBottom: 10 }}>Company Name</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    value={name}
                    onChange={e => setName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter company name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <AddressSearch
                  includeMap={false}
                  initialValue={physicalAddress}
                  handleChange={event => {
                    setPhysicalAddress(event.address);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MultiDropdownApi
                  required={true}
                  apiPath="industry"
                  optionLabel="name"
                  optionValue="id"
                  label="Industry"
                  selectedData={industry}
                  setSelectedData={setIndustry}
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Registration number</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    value={registrationNumber}
                    onChange={e => setRegistrationNumber(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter registration number"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Vat Number</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    value={vatNumber}
                    onChange={e => setVatNumber(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter vat number"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Admin Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    value={adminName}
                    onChange={e => setAdminName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter admin name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    value={adminSurname}
                    onChange={e => setAdminSurname(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter admin surname"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Mobile</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <PhoneInput
                    defaultCountry="za"
                    value={adminMobile}
                    onChange={e => setAdminMobile(e)}
                    inputStyle={{ width: "100%" }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Email</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <div className="p-inputgroup ">
                    <span className="p-inputgroup-addon PrimeSmallInput">
                      <AlternateEmailOutlined />
                    </span>
                    <InputText
                      style={{ width: "100%" }}
                      value={adminEmail}
                      onChange={e => setAdminEmail(e.target.value)}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                      placeholder="Please admin email"
                    />
                  </div>
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="SACPCMP">
          <Card>
            <Grid container spacing={2}>
              <Grid item style={{ margin: "auto" }} xs={1}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <Avatar
                    style={{ width: 150, height: 150 }}
                    image={sacpcmpImgSrc}
                    shape="circle"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormLabel style={{ marginBottom: 10 }}>
                      SACPCMP ID{" "}
                      <a
                        style={{ marginLeft: 15 }}
                        href="https://search.mymembership.co.za/Search/?Id=e32e242a-44bd-475d-9e98-53a9fbbd2caf"
                        target="_blank"
                      >
                        Search
                      </a>
                    </FormLabel>
                    <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                      <InputText
                        value={sacpcmpId}
                        onChange={e => setSacpcmpId(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                        placeholder="Please enter SACPCMP id"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel style={{ marginBottom: 10 }}>Full Name</FormLabel>
                    <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                      <InputText
                        disabled={true}
                        value={sacpcmpFullName}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                        placeholder="No SACPCMP Details"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Title</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpTitle}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Registration Status</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpRegistrationStatus}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormLabel style={{ marginBottom: 10 }}>Registration Category</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpRegistrationCategory}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Registration Number</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpRegistrationNumber}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Membership Number</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpMembershipNumber}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Good Standing from</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpGoodStandingFrom}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Good Standing to</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputText
                    disabled={true}
                    value={sacpcmpGoodStandingTo}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="No SACPCMP Details"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            type="consultant"
            props={props}
          />
        </TabPanel>
      </TabView>

      <Toast ref={toast} />
    </Fragment>
  );
}
